export default __webpack_public_path__ + "static/media/foodBank.921fcd0b.png";